import { useContext, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "react-toastify";
import { Button } from "../ui/button";
import api from "../../services/api";
import openSocket from "../../services/socket-io";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";

export default function ImportWhatsAppProgress({ conexao }) {
  const { user } = useContext(AuthContext);
  const [estado, setEstado] = useState(conexao.statusImportMessages);
  const [progresso, setProgresso] = useState(null);
  const [fechando, setFechando] = useState(false);
  useEffect(() => setEstado(conexao.statusImportMessages), [conexao.statusImportMessages]);
  useEffect(() => {
    const socket = openSocket();
    socket.on(`importMessages-${user.companyId}`, async dados => {
      if (Number(dados.whatsappId) !== Number(conexao.id)) return;
      if (dados.action === "update") { setProgresso(dados.status); setEstado("Running"); }
      else {
        try { const { data } = await api.get(`/whatsapp/${conexao.id}`); setEstado(data.statusImportMessages); setProgresso(null); }
        catch (err) { toastError(err); }
      }
    });
    return () => socket.disconnect();
  }, [conexao.id, user.companyId]);
  const fechar = async () => {
    setFechando(true);
    try {
      await api.post(`/closedimported/${conexao.id}`);
      setEstado(null);
      toast.success("Tickets importados encerrados com sucesso!");
    } catch (err) { toastError(err); }
    finally { setFechando(false); }
  };
  if (estado === "renderButtonCloseTickets") return <Button size="sm" variant="outline" disabled={fechando} onClick={fechar}>Encerrar tickets importados</Button>;
  if (!estado) return null;
  if (estado === "failed") return <span className="text-xs text-destructive">Falha na importação</span>;
  return <div className="flex items-center gap-2 text-xs text-muted-foreground" role="status">
    <Loader2 className="h-3 w-3 animate-spin" />
    {estado === "Running" ? <span>Importando mensagens {progresso ? `${progresso.this} de ${progresso.all}` : ""}{progresso?.date && ` — ${new Date(progresso.date).toLocaleString("pt-BR")}`}</span> : "Preparando mensagens para importação"}
  </div>;
}
